// extracted by mini-css-extract-plugin
module.exports = {"Root":"Container_Root__vlfaC","Header":"Container_Header__L10vV","Header___withoutRadius":"Container_Header___withoutRadius__kvPyv"};